/**
 * Constants.ts
 *
 * Module to hold logging-related constants
 */

export interface ICustomProperties {
	CampaignId?: string;
	ErrorMessage?: string;
	FeedbackType?: number;
	FileName?: string;
	HttpStatusCode?: number;
	IsBugEnabled?: boolean;
	IsDiagnosticsIncluded?: boolean;
	IsEmailIncluded?: boolean;
	IsIdeaEnabled?: boolean;
	IsScreenshotIncluded?: boolean;
	SurveyId?: string;
	SurveyType?: number;
	TimeMilliseconds?: number;
}

export interface IEventId {
	name: string;
}

export class EventIds {
	public static InApp = class {
		public static UI = class {
			public static Picker = class {
				public static Shown = class {
					public static VALUE: IEventId = { name: "InApp_UI_Picker_Shown" };
				};
			};

			public static Form = class {
				public static Shown = class {
					public static VALUE: IEventId = { name: "InApp_UI_Form_Shown" };
				};

				public static Submit = class {
					public static VALUE: IEventId = { name: "InApp_UI_Form_Submit" };
				};
			};
		};
	};

	public static Survey = class {
		public static UI = class {
			public static Prompt = class {
				public static Shown = class {
					public static VALUE: IEventId = { name: "Survey_UI_Prompt_Shown" };
				};
			};

			public static Form = class {
				public static Shown = class {
					public static VALUE: IEventId = { name: "Survey_UI_Form_Shown" };
				};

				public static Submit = class {
					public static VALUE: IEventId = { name: "Survey_UI_Form_Submit" };
				};
			};
		};

		public static Floodgate = class {
			public static TriggerMet = class {
				public static VALUE: IEventId = { name: "Survey_Floodgate_TriggerMet" };
			};

			public static UserSelected = class {
				public static VALUE: IEventId = { name: "Survey_Floodgate_UserSelected" };
			};

			public static CampaignLoad = class {
				public static Failed = class {
					public static VALUE: IEventId = { name: "Survey_Floodgate_CampaignLoad_Failed" };
				};
			};

			public static FileWrite = class {
				public static Failed = class {
					public static VALUE: IEventId = { name: "Survey_Floodgate_FileWrite_Failed" };
				};
			};

			public static FileRead = class {
				public static Failed = class {
					public static VALUE: IEventId = { name: "Survey_Floodgate_FileRead_Failed" };
				};
			};
		};
	};

	public static Shared = class {
		public static Upload = class {
			public static Failed = class {
				public static VALUE: IEventId = { name: "Shared_Upload_Failed" };
			};
		};

		public static Screenshot = class {
			public static Render = class {
				public static Failed = class {
					public static VALUE: IEventId = { name: "Shared_Screenshot_Render_Failed" };
				};
				public static Success = class {
					public static VALUE: IEventId = { name: "Shared_Screenshot_Render_Success" };
				};
			};

			public static GetContent = class {
				public static Failed = class {
					public static DefaultImage = class {
						public static Returned = class {
							public static VALUE: IEventId = { name: "Shared_Screenshot_GetContent_Failed_DefaultImage_Returned" };
						};
					};
				};
			};
		};
	};
}
